import { Link } from "react-router-dom";
import { Button } from "../components/ui/Button";
import Logo from "../components/common/Logo";
import type { ReactNode } from "react";

export default function PublicShell({
  children,
  minimal = false,
}: {
  children: ReactNode;
  minimal?: boolean;
}) {
  return (
    <div className="min-h-screen flex flex-col relative">
      <a href="#main" className="skip-link">Skip to main content</a>
      <header className="relative z-10 border-b border-[rgba(42,36,26,0.12)]">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
          <Link to="/" className="shrink-0"><Logo size="md" /></Link>
          {!minimal && (
            <nav className="hidden md:flex items-center gap-8 text-[0.9rem] text-ink-soft">
              <a href="/#how" className="hover:text-terracotta transition-colors">How it works</a>
              <a href="/#languages" className="hover:text-terracotta transition-colors">Languages</a>
              <a href="/#pricing" className="hover:text-terracotta transition-colors">Pricing</a>
            </nav>
          )}
          <div className="flex items-center gap-3">
            <Link to="/login" className="text-[0.9rem] text-ink-soft hover:text-terracotta transition-colors px-3 py-2">
              Sign in
            </Link>
            <Link to="/signup">
              <Button size="sm">Begin</Button>
            </Link>
          </div>
        </div>
      </header>
      <main id="main" className="flex-1 relative z-10">{children}</main>
      <footer className="relative z-10 bg-ink-card text-paper/70 mt-24">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-14 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2">
            <Logo size="md" variant="paper" />
            <p className="mt-4 text-sm max-w-sm text-paper/60">
              A quiet little tutor that lives in your Telegram and slips new words into every reply.
            </p>
          </div>
          <div>
            <div className="eyebrow text-paper/40 mb-3">Product</div>
            <ul className="space-y-2 text-sm">
              <li><a href="/#how" className="hover:text-terracotta-soft">How it works</a></li>
              <li><a href="/#personas" className="hover:text-terracotta-soft">Personas</a></li>
              <li><a href="/#pricing" className="hover:text-terracotta-soft">Pricing</a></li>
            </ul>
          </div>
          <div>
            <div className="eyebrow text-paper/40 mb-3">Company</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy" className="hover:text-terracotta-soft">Privacy</Link></li>
              <li><Link to="/terms" className="hover:text-terracotta-soft">Terms</Link></li>
              <li><a href="mailto:hello@ilmli.ai" className="hover:text-terracotta-soft">Contact</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/5 py-6 text-center text-xs text-paper/40 font-mono">
          © {new Date().getFullYear()} ilmli · made for the curious
        </div>
      </footer>
    </div>
  );
}
